import RootApp from "./App.vue";
import initializeApp from "./core";
import { createSSRApp } from "vue";

const app = createSSRApp(RootApp);

initializeApp(app);
